module.exports = __webpack_public_path__ + "assets/img/7_948_big.2cf43d8c.jpg";